<template>
  <i-menu class="nav-menu" mode="horizontal" theme="dark">
    <!-- <router-link class="ivu-menu-item ivu-menu-item--demo" to="/app/dashboard">
      Задачи
    </router-link> -->
    <router-link
      v-for="link in filteredMainLinks"
      :key="link.id"
      class="ivu-menu-item"
      :to="link.path"
    >
      {{ link.name }}
    </router-link>

    <submenu v-if="filteredSecondaryLinks.length" name="4">
      <template slot="title">Еще</template>
      <router-link
        v-for="link in filteredSecondaryLinks"
        :key="link.id"
        class="ivu-menu-item"
        :to="link.path"
      >
        {{ link.name }}
      </router-link>
    </submenu>
  </i-menu>
</template>

<script>
const freeModules = ['main', 'contracts']
const mainLinks = [
  // {
  //   id: 'main',
  //   name: 'Главная',
  //   path: '/app/dashboard'
  // },
  {
    id: 'contracts',
    name: 'Проекты',
    path: '/app/contracts'
  },
  {
    id: 'time-table',
    name: 'План-график',
    path: '/app/time-table'
  },
  {
    id: 'contract_register',
    name: 'Реестр',
    path: '/app/contracts-register'
  },
  {
    id: 'experience',
    name: 'Опыт',
    path: '/app/experience'
  }
]
const secondaryLinks = [
  // {
  //   id: 'contract_acts',
  //   name: 'Акты',
  //   path: '/app/acts'
  // },
  // {
  //   id: 'contract_payments',
  //   name: 'Платежи',
  //   path: '/app/payments'
  // },
  // {
  //   id: 'procedure',
  //   name: 'Запросы материалов',
  //   path: '/app/procedures'
  // },
  {
    id: 'law_cases',
    name: 'Судебные дела',
    path: '/app/law-cases'
  },
  {
    id: 'reports',
    name: 'Отчеты',
    path: '/app/reports'
  },
  {
    id: 'books',
    name: 'Справочники',
    path: '/app/books'
  }
]

export default {
  computed: {
    filteredMainLinks () {
      return mainLinks.filter(l => this.hasModule(l.id))
    },
    filteredSecondaryLinks () {
      return secondaryLinks.filter(l => this.hasModule(l.id))
    }
  },
  methods: {
    hasModule (module) {
      if (freeModules.includes(module)) return true

      return this.$store.getters.hasModule(module)
    }
  }
}
</script>

<style lang="less">
.nav-menu {
  &.ivu-menu-horizontal {
    height: 40px;
    line-height: 40px;
    font-size: 12px;

    .ivu-menu-item {
      font-size: 12px;
      padding: 0 12px;
      position: relative;

      &--demo {
        &:after {
          content: 'BETA';
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          background-color: @primary-color;
          font-size: 8px;
          height: 12px;
          line-height: 12px;
          padding-right: 2px;
          padding-left: 4px;
          letter-spacing: 1px;
          border-bottom-left-radius: 4px;
        }
      }
    }

    .ivu-menu-submenu {
      padding: 0 12px;
      z-index: 1000;

      .ivu-select-dropdown {
        z-index: 1000;
        .ivu-menu-item {
          font-size: 12px !important;
        }
      }
    }
  }
}
</style>
